// extracted by mini-css-extract-plugin
export default {"container":"ReleasesDeleteModal_container__IjEhT","description":"ReleasesDeleteModal_description__LuG1z"};